<app-card-resume-dashboard class="flex w-full flex-row flex-wrap gap-4 p-4 pb-40"></app-card-resume-dashboard>
